import './tooltip.css'

let activeTooltip = null
let showTimer = null

function clearActive() {
    if (showTimer) {
        clearTimeout(showTimer)
        showTimer = null
    }
    if (activeTooltip) {
        activeTooltip.classList.remove('v-tooltip--visible')
        setTimeout(() => {
            if (activeTooltip && !activeTooltip.classList.contains('v-tooltip--visible')) {
                activeTooltip.remove()
                activeTooltip = null
            }
        }, 150)
    }
}

function show(el) {
    const text = el._tooltipText
    if (!text) return

    clearActive()

    showTimer = setTimeout(() => {
        const tip = document.createElement('div')
        tip.className = 'v-tooltip'
        tip.textContent = text
        document.body.appendChild(tip)
        activeTooltip = tip

        const rect = el.getBoundingClientRect()
        const tipRect = tip.getBoundingClientRect()
        const gap = 6

        const spaceBelow = window.innerHeight - rect.bottom
        const placeTop = spaceBelow < tipRect.height + gap + 20

        let left = rect.left + rect.width / 2
        let top

        if (placeTop) {
            top = rect.top - tipRect.height - gap
            tip.classList.add('v-tooltip--top')
        } else {
            top = rect.bottom + gap
        }

        if (left - tipRect.width / 2 < 8) left = tipRect.width / 2 + 8
        if (left + tipRect.width / 2 > window.innerWidth - 8) left = window.innerWidth - tipRect.width / 2 - 8

        tip.style.left = left + 'px'
        tip.style.top = top + 'px'

        requestAnimationFrame(() => {
            if (activeTooltip === tip) tip.classList.add('v-tooltip--visible')
        })
    }, 400)
}

function hide() {
    clearActive()
}

export const tooltipDirective = {
    mounted(el, binding) {
        el._tooltipText = binding.value || ''
        el._tooltipShow = () => show(el)
        el._tooltipHide = hide
        el.addEventListener('mouseenter', el._tooltipShow)
        el.addEventListener('mouseleave', el._tooltipHide)
        el.addEventListener('mousedown', el._tooltipHide)
    },
    updated(el, binding) {
        el._tooltipText = binding.value || ''
    },
    beforeUnmount(el) {
        el.removeEventListener('mouseenter', el._tooltipShow)
        el.removeEventListener('mouseleave', el._tooltipHide)
        el.removeEventListener('mousedown', el._tooltipHide)
        if (activeTooltip) {
            activeTooltip.remove()
            activeTooltip = null
        }
    },
}

export default {
    install(app) {
        app.directive('tooltip', tooltipDirective)
    },
}
